import { type KpiLine, KpiLineText, kpiLineKey } from './KpiLineText';

import styles from './FeedingKpiCard.module.scss';

export interface KpiDetail {
    label: string;
    /** One line per entry, so a row holding two facts shows them on two lines. */
    value: KpiLine | KpiLine[];
}

interface KpiDetailsProps {
    details: KpiDetail[];
}

/**
 * The card's facts beside its values, one labelled row each, so no fact runs into the next
 * and every number says what it is (owner ask 1).
 */
export function KpiDetails(props: KpiDetailsProps) {
    return (
        <dl className={styles.details}>
            {props.details.map((detail) => (
                <div key={detail.label} className={styles.detail}>
                    <dt>{detail.label}</dt>
                    {(Array.isArray(detail.value) ? detail.value : [detail.value]).map((line) => (
                        <dd key={kpiLineKey(line)}>
                            <KpiLineText line={line} />
                        </dd>
                    ))}
                </div>
            ))}
        </dl>
    );
}
